import React, {Component} from 'react';
import {connect} from 'react-redux'

class ThankYou extends Component {
    render() {
        let messageList = this.props.location.state.message.map((message, index) => {
            return (<p key={index}>{message.text || message}</p> )
        })
        return (
            <header className="header__thank">
                <div className="container"><a className="header__thank-logo" href="/"><img
                    src="assets/images/logo-black.png" alt=""/></a>
                    <h2 className="header__thank-title">Thank You!</h2>
                    <div className="header__thank-subtitle">
                        {messageList}
                    </div>
                </div>
            </header>
        )
    }
}


export default connect()(ThankYou)



// WEBPACK FOOTER //
// ./src/component/ThankYou.js